import { jsx as n } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useState as u, useRef as y, useCallback as h, useMemo as T } from "../../../external/preact/hooks/dist/hooks.module.js";
/* empty css          */
import _ from "../../../core/Context/useCoreContext.js";
import g from "../Typography/Typography.js";
import { TypographyVariant as I, TypographyElement as N } from "../Typography/types.js";
import { InteractionKeyCode as r } from "../../types.js";
function O(s) {
  const i = s.tabs, { i18n: d } = _(), c = s.defaultActiveTab ? s.tabs.findIndex((e) => e.id === s.defaultActiveTab) : 0, [t, b] = u(c === -1 ? 0 : c), f = y({}), o = h((e) => {
    const a = f.current[e];
    a == null || a.focus();
  }, []), p = T(() => {
    const e = i.length, a = {
      [r.ARROW_RIGHT]: () => o((t + 1) % e),
      [r.ARROW_LEFT]: () => o((t - 1 + e) % e),
      [r.HOME]: () => o(0),
      [r.END]: () => o(e - 1)
    };
    return (l) => {
      var m;
      a[l.key] && (l.preventDefault(), (m = a[l.key]) == null || m.call(a));
    };
  }, [i.length, t, o]);
  return /* @__PURE__ */ n("section", { "aria-label": d.get("tabs"), children: [
    /* @__PURE__ */ n("div", { className: "adyen-fp-tabs", role: "tablist", "aria-orientation": "horizontal", children: i.map((e, a) => /* @__PURE__ */ n(
      "button",
      {
        id: `tab-id-${e.id}`,
        name: e.id,
        className: "adyen-fp-tabs__tab",
        role: "tab",
        "aria-controls": `panel-id-${e.id}`,
        "aria-selected": t === a,
        ref: (l) => f.current[a] = l,
        onKeyDown: p,
        onClick: a === t ? void 0 : () => b(a),
        onFocus: () => b(a),
        tabIndex: t === a ? 0 : -1,
        disabled: e.disabled,
        children: /* @__PURE__ */ n(
          g,
          {
            variant: I.BODY,
            el: N.SPAN,
            stronger: !0,
            className: "adyen-fp-tabs__tab-content-tab-label",
            children: d.get(e.label)
          }
        )
      },
      `tab-${e.id}`
    )) }),
    /* @__PURE__ */ n("div", { className: "adyen-fp-tabpanel__wrapper", children: i.map((e, a) => /* @__PURE__ */ n(
      "section",
      {
        className: "adyen-fp-tabpanel__content",
        id: `panel-id-${e.id}`,
        hidden: t !== a,
        role: "tabpanel",
        "aria-labelledby": `tab-id-${e.id}`,
        children: e.content
      },
      `tabpanel-${e.id}`
    )) })
  ] });
}
export {
  O as default
};
